<template>
  <v-menu
    v-model="isMenuOpen"
    :close-on-content-click="false"
    offset-y
    transition="slide-y-transition"
  >
    <template #activator="{ on, attrs }">
      <v-chip
        label
        small
        class="onedrive-attachment-item"
        v-bind="attrs"
        v-on="on"
      >
        <v-icon
          left
          color="blue darken-2"
          small
        >
          mdi-microsoft-sharepoint
        </v-icon>
        <span
          class="mr-1 text-truncate chip-filename"
        >
          {{ file.file_name }}
        </span>
        <span
          v-if="file.file_size"
          class="text-caption grey--text"
        >
          ({{ humanReadableFileSize }})
        </span>
      </v-chip>
    </template>

    <v-card
      class="onedrive-attachment-info-card"
    >
      <v-card-text
        class="pa-2 text-caption"
      >
        <div
          class="d-flex ma-2"
        >
          <v-btn
            color="secondary"
            x-small
            dark
            depressed
            :href="file.sharepoint_url"
            target="_blank"
            rel="noopener noreferrer"
          >
            <v-icon left>
              mdi-open-in-new
            </v-icon>
            Open in SharePoint
          </v-btn>
        </div>

        <div
          v-if="thumbnailUrl"
          class="d-flex justify-center pa-1"
        >
          <div
            class="mx-auto pa-2 rounded-lg content-preview"
          >
            <v-img
              contain
              width="300"
              min-height="200"
              :src="thumbnailUrl"
            />
          </div>
        </div>

        <div
          v-else
          class="grey lighten-2 py-4 rounded text--grey text-center no-preview"
        >
          No preview available
        </div>

        <div
          class="d-flex ma-2"
        >
          <div
            v-if="file.file_size"
            class="d-flex me-4"
          >
            <v-icon
              small
              left
            >
              mdi-paperclip
            </v-icon>
            <span>{{ humanReadableFileSize }}</span>
          </div>

          <div
            v-if="file.mime_type"
            class="d-flex me-4"
          >
            <v-icon
              small
              left
            >
              mdi-file-outline
            </v-icon>
            <span>{{ file.mime_type }}</span>
          </div>
        </div>

        <div
          class="align-start d-flex ma-2"
        >
          <v-icon
            left
            small
            color="blue darken-2"
          >
            mdi-microsoft-sharepoint
          </v-icon>
          <span class="text-caption grey--text">SharePoint</span>
        </div>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
import { mapActions } from 'vuex'

import { alertHandler } from '@/alertHandler'
import { formatSize } from '@/utilities'

import { DOCKET_ENTRY_NAMESPACE } from '@/store/docket-entry'

export default {
  name: 'OneDriveAttachmentItem',

  props: {
    file: {
      type: Object,
      required: true,
    },
  },

  setup () {
    return {
      ...alertHandler(),
    }
  },

  data () {
    return {
      isMenuOpen: false,
      thumbnailUrl: this.file.thumbnail_url || null,
    }
  },

  computed: {
    humanReadableFileSize () {
      return this.file.file_size ? formatSize(this.file.file_size) : ''
    },
  },

  watch: {
    isMenuOpen (val) {
      if (val && !this.thumbnailUrl) this.loadThumbnail()
    },
  },

  methods: {
    loadThumbnail () {
      this.getSharepointFileThumbnail(this.file.id).
        then(data => {
          this.thumbnailUrl = data.thumbnail_url
        }).
        catch(_ => {
          this.displayAlert('error', 'Could not load SharePoint file preview')
        })
    },

    ...mapActions(DOCKET_ENTRY_NAMESPACE, [
      'getSharepointFileThumbnail',
    ]),
  },
}
</script>

<style lang="scss" scoped>
.onedrive-attachment-item {
  margin: 2px;

  .chip-filename {
    max-width: 200px;
  }
}

.onedrive-attachment-info-card {
  .content-preview {
    border: 1px solid #dedede;
  }

  .no-preview {
    padding: 30px;
  }
}
</style>
